'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndConnection } from '../../Entities/Ind/IndConnection';

export class IndConnectionRepository extends CoreRepository {
  public addIndConnection(userId: number, individualId: number, payload: any[]) {
    return this.webAPI.addIndConnection(userId, individualId, payload).then((response) => {
      return response;
    });
  }

  public getIndConnections(userId: number, individualId: number) {
    return this.webAPI.getIndConnections(userId, individualId).then((response) => {
      return response;
    });
  }

  public removeIndConnection(userId: number, individualId: number, payload: any[]) {
    return this.webAPI.removeIndConnection(userId, individualId, payload).then((response) => {
      return response;
    });
  }

  public updateIndConnection(
    userId: number,
    individualId: number,
    connectionId: number,
    payload: any[]
  ) {
    return this.webAPI
      .updateIndConnection(userId, individualId, connectionId, payload)
      .then((response) => {
        return response;
      });
  }
}
